<div class="row">
	<app-loading-modal [visible]="isLoading" [message]="'Generando reporte'"></app-loading-modal>
	<app-client-modal
		[visible]="showClientModal"
		[selectedClientId]="selectedClient"
		[clientes]="clientes"
		(onAccept)="handleClientSelection($event)"
		(onCancel)="showClientModal = false">
	</app-client-modal>
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
				<span class="reels-title">
					<i class="fa fa-img"></i> Lista de Unidades
				</span>
				<div *ngIf="isAdmin" class="filter-actions">
				<p-dropdown
					[options]="clientes"
					optionLabel="nombre_comercial"
					optionValue="id"
					[(ngModel)]="selectedClientId"
					(ngModelChange)="onClientChange()"
					styleClass="p-dropdown-sm"
					[filter]="true"
					placeholder="Selecciona un cliente"
				></p-dropdown>

				<button
					*ngIf="selectedClientId"
					type="button"
					class="btn btn-sm btn-outline-secondary btn-clear"
					(click)="clearClientFilter()"
					title="Quitar filtro"
				>
					<i class="fa fa-times"></i>
				</button>
				</div>
				<span class="btn-add-container" *ngIf="isAdmin">
					<button class="btn btn-primary btn-add" (click)="add()">
						<i class="fa fa-plus-square"></i>
						Agregar Unidad
					</button>
				</span>
				<span class="btn-add-container" *ngIf="isAdmin">
					<button class="btn btn-primary btn-add" (click)="openModalClient()">
						<i class="fa-solid fa-file-doc"></i>
						Generar reporte
					</button>
				</span>
			</div>
			<div class="card-body">
				<app-datatable [options]="dtConfig"></app-datatable>
			</div>
		</div>
	</div>
</div>
